import React from 'react';

import classnames from 'classnames';

import Layout from 'components/layout/Layout';
import Header from 'components/layout/Header';
import CollectionDetail from 'components/collection/CollectionDetail';

const CollectionTemplate = ({
  pageContext: {
    collection: { name, description, tools, image, slug },
  },
  className,
  location,
}) => {
  return (
    <Layout className={classnames('layout-collection', className)}>
      <Header />
      <CollectionDetail
        name={name}
        description={description}
        tools={tools}
        image={image}
        prevPath={location.state?.prevPath}
        slug={slug}
      />
    </Layout>
  );
};

export default CollectionTemplate;
